import { Layout, Avatar, Dropdown, Typography, Space } from "antd";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import type { MenuProps } from "antd";
import { useAuth } from "@/hooks/useAuth";

const { Header: AntHeader } = Layout;
const { Text } = Typography;

export default function Header() {
  const { user, signOut } = useAuth();

  const userMenuItems: MenuProps["items"] = [
    {
      key: "email",
      label: (
        <Text type="secondary" style={{ fontSize: 12 }}>
          {user?.email || ""}
        </Text>
      ),
      disabled: true,
    },
    {
      type: "divider",
    },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Sign out",
      danger: true,
    },
  ];

  const handleUserMenuClick: MenuProps["onClick"] = ({ key }) => {
    if (key === "logout") {
      signOut();
    }
  };

  return (
    <AntHeader
      style={{
        background: "#ffffff",
        padding: "0 24px",
        borderBottom: "1px solid #E5E7EB",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        position: "sticky",
        top: 0,
        zIndex: 99,
        height: 56,
      }}
    >
      <Space size={8}>
        <Dropdown
          menu={{
            items: userMenuItems,
            onClick: handleUserMenuClick,
          }}
          trigger={["click"]}
          placement="bottomRight"
        >
          <Space
            style={{
              cursor: "pointer",
              padding: "4px 12px 4px 6px",
              borderRadius: 8,
            }}
          >
            <Avatar
              size={28}
              icon={<UserOutlined />}
              style={{
                background: "linear-gradient(135deg, #0F6E56 0%, #0A5240 100%)",
              }}
            />
            <Text style={{ fontWeight: 500, color: "#1F2937", fontSize: 13 }}>
              {user?.name || user?.email || "User"}
            </Text>
          </Space>
        </Dropdown>
      </Space>
    </AntHeader>
  );
}
